<template>
    <div class="form-group">
        <label>{{ name }}</label>
        <div class="input-group">
            <input type="text" :name="'filter_'+id" :title="name" v-model="v_from" class="form-control">
            <span class="input-group-addon">{{ t_to }}</span>
            <input type="text" :name="'filter_'+id" :title="name" v-model="v_to" class="form-control">
        </div>
    </div>
</template>

<script>
    export default {
        props: ['id', 'name', 'value'],
        data: function() {
            return {
                t_to: Lang.langGet("to"),
                value_inner: this.value,
                v_from: this.value.split(':')[0] || '',
                v_to: this.value.split(':')[1] || '',
            }
        },
        watch: {
            v_from: function(val, oldVal) {
                this.combine();
            },
            v_to: function(val, oldVal) {
                this.combine();
            },
            value_inner: function(val, oldVal) {
                EaseEventBus.fire('resetExistingFilters');
                this.$emit('input', val);
            }
        },
        methods: {
            combine: function() {
                let combined = this.v_from + ':' + this.v_to;
                this.value_inner = combined;
            }
        }
    }
</script>
